'use client'

import {usePlayButton} from '@app/components/gameplayer-page/game-image-and-play-btn/play-btn/play-button-context'
import {ReactNode} from 'react'
import {requestFullScreen, useFullScreenChange} from './full-screen-provider'
import triggerAnalytics from '@gamezop/analytics-sdk/client/trigger-analytics'

type Props = {
  children: ReactNode
  className?: string
  gameNameEn: string
  gameCode: string
}

const FullScreenBtnWrapper = ({children, className, gameNameEn, gameCode}: Props) => {
  const {gameScreenShown, showGameScreen} = usePlayButton()

  const handleClick = () => {
    if (!gameScreenShown) {
      showGameScreen()
    }
    requestFullScreen()
  }

  useFullScreenChange({
    onFullScreenEnter: triggerAnalytics('full-screen-triggered', {
      'game-name': gameNameEn,
      'game-code': gameCode,
    }).sendAll,
    onFullScreenExit: triggerAnalytics('exit-full-screen', {
      'game-name': gameNameEn,
      'game-code': gameCode,
    }).sendAll,
  })

  return (
    <button onClick={handleClick} className={className}>
      {children}
    </button>
  )
}

export default FullScreenBtnWrapper
